import { useSelector } from 'react-redux';
import { useEffect } from 'react';

export function useFavicon() {
    const faviconSetting = useSelector(
        (state) => state.appState.setting.content.navbar.favicon
    );

    useEffect(() => {
        const setFavicon = function (url) {
            if (!url) return;
            // Find the current favicon element
            const favicon = document.querySelector('link[rel="icon"]');
            if (favicon) {
                // Update the new link
                favicon.href = url;
            } else {
                // Create new `link`
                const link = document.createElement('link');
                link.rel = 'icon';
                link.href = url;
                // Append to the `head` element
                document.head.appendChild(link);
            }
        };
        setFavicon(faviconSetting);
    }, [faviconSetting]);
}
